import * as Crypto from 'crypto-js';
import {DATA_SECRET} from './../../constants/constants';

/**
 * Function for setting the localstorage value/'s(in encrypted format)
 * @param key String
 * @param value Any
 */
export const setLocalStorageValue = (key: string, value: any) => {
    const securedata = Crypto.AES.encrypt(value, DATA_SECRET);
    localStorage.setItem(key, securedata);
}

/**
 * Function for getting the localstorage value(in decrypted format) for the provided key
 * @param key String
 */
export const getLocalStorageValue = (key: string) => {
        const lsValue = localStorage.getItem(key);
        if(lsValue) {
            const decryptedValue = Crypto.AES.decrypt(lsValue, DATA_SECRET);
            if(decryptedValue){
                const vv = decryptedValue.toString(Crypto.enc.Utf8)
                if(vv){
                    return JSON.parse(vv);
                }
                else{
                    return null;
                }
                
            }
            else{
                return null;
            }
        } else {
            return null;
        }
}

/**
 * function for clearing the localstorage
 */
export const clearLocalStorageValue = () => {
    localStorage.clear();
};

export const clearLocalStorageValueForKey = (key: string) => {
    localStorage.removeItem(key);
}


// WEBPACK FOOTER //
// ./src/effects/utils/local-storage.tsx